export enum ClientErrorCodes {
    InvalidCaptcha = -3
}